
import Vue from 'vue'
import Contact from './contact';
import axios from 'axios';

export default Vue.extend({
    props: {
        contact: Object as () => Contact,
        // displayTitle: String,
        // contactEmail: String
    },
    data() {
        return {
            displaySuccessMsg: false,
            name: '',
            emailAddress: '',
            msg: ''
        }
    },
    methods: {
      isValidEmail: function (email: string): boolean {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email.trim());
      },
        submit: async function () {
            
            let antiForgeryToken = document.querySelector<HTMLInputElement>('input[name=__RequestVerificationToken]').value

            try {
                
                if (!this.name || !this.emailAddress || !this.msg 
                    || this.emailAddress.trim().length == 0 || this.name.trim().length == 0 || this.msg.trim().length == 0
                    ) {
                    alert('Please fill out all fields (your name, email address and message)')
                    return;
                }
                if (!this.isValidEmail(this.emailAddress)) {
                  alert('Please enter a valid email address');
                  return;
              }
            //    let result = axios.post('/Contact?handler=SendMessage&contactID=2&name=test&email=test@test.com&subject=testSub&msg="msg')
                // let result = axios.post({url: '/Contact?handler=SendMessage', headers: {  "RequestVerificationToken": antiForgeryToken  }})
                let result = axios.post(`/Contact?handler=SendMessage&contactID=${this.contact.contactID}&name=${this.name}&email=${this.emailAddress}`,this.msg, {
                
                    headers: {  "RequestVerificationToken": antiForgeryToken ,
                        'content-type': 'application/json', 
                     }
                })

                this.displaySuccessMsg = true;

                   setTimeout(() => {
                        this.displaySuccessMsg = false;
                        this.$emit('cancel');    
                        
                    }, 2500);
            } catch (error) {
                alert('Sorry something went wrong');
            }
         
        }
    }
})
